export interface ViaCEPResponse {
  cep: string
  logradouro: string
  complemento: string
  bairro: string
  localidade: string
  uf: string
  ibge: string
  gia: string
  ddd: string
  siafi: string
  erro?: boolean
}

export interface AddressData {
  street: string
  neighborhood: string
  city: string
  state: string
  zipCode: string
}

export const fetchAddressByCEP = async (cep: string): Promise<AddressData | null> => {
  try {
    // Remove caracteres não numéricos do CEP
    const cleanCEP = cep.replace(/\D/g, '')
    
    // Valida se o CEP tem 8 dígitos
    if (cleanCEP.length !== 8) {
      throw new Error('CEP deve ter 8 dígitos')
    }

    // Faz a consulta para a API do ViaCEP
    const response = await fetch(`https://viacep.com.br/ws/${cleanCEP}/json/`)
    
    if (!response.ok) {
      throw new Error('Erro ao consultar CEP')
    }

    const data: ViaCEPResponse = await response.json()

    // Verifica se o CEP foi encontrado
    if (data.erro) {
      throw new Error('CEP não encontrado')
    }

    // Retorna os dados formatados
    return {
      street: data.logradouro || '',
      neighborhood: data.bairro || '',
      city: data.localidade || '',
      state: data.uf || '',
      zipCode: cleanCEP
    }
  } catch (error) {
    console.error('Erro ao consultar CEP:', error)
    throw error
  }
}

export const formatCEP = (cep: string): string => {
  // Remove caracteres não numéricos
  const cleanCEP = cep.replace(/\D/g, '')
  
  // Aplica a máscara 00000-000
  return cleanCEP.replace(/(\d{5})(\d{3})/, '$1-$2')
}
